import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { Route } from '@/types';
import { RouteCard } from '../RouteCard';

interface SortableRouteCardProps {
  route: Route;
  onHide?: (routeId: string) => void;
}

export function SortableRouteCard({ route, onHide }: SortableRouteCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: route.global_route_id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? 'grabbing' : 'grab',
  };

  return (
    <div ref={setNodeRef} style={style} className="route" {...attributes} {...listeners}>
      <RouteCard route={route} onHide={onHide} />
    </div>
  );
}
